module.exports = __webpack_public_path__ + "img/ico-overview.680bf764.svg";